module.exports = __webpack_public_path__ + "static/62invgde-9b35d008f8148623a09987e7bcbce8a1.gif";